module.exports = __webpack_public_path__ + "img/leapoai-product.e3d12a9f.jpg";